module.exports = __webpack_public_path__ + "static/media/comment.7093a73e.svg";